import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class PinIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" width="11.738" height="16.001" viewBox="0 0 11.738 16.001"><path d="M5.869 0a5.875 5.875 0 0 1 5.869 5.869c0 4.184-5.022 9.626-5.237 9.856a.863.863 0 0 1-1.265 0C5.022 15.495 0 10.053 0 5.869A5.875 5.875 0 0 1 5.869 0zM3.553 5.684a2.316 2.316 0 1 0 2.316-2.317 2.316 2.316 0 0 0-2.316 2.317z"/></svg>
        )
    }
}

export default withCssClassName(PinIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/pin-icon.js